var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcSearchActiveSmallDisabled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.16972 12.7432C4.17984 12.7432 1.72892 10.2535 1.72892 7.24036C1.72892 4.21625 4.17984 1.73726 7.16972 1.73726C10.1488 1.73726 12.6103 4.21625 12.6103 7.24036C12.6103 10.2535 10.1488 12.7432 7.16972 12.7432ZM7.16972 13.4805C8.60635 13.4805 9.9482 12.9675 10.9941 12.1128L15.4944 16.6755C15.5999 16.7823 15.7585 16.8571 15.9171 16.8571C16.2975 16.8571 16.5403 16.5685 16.5403 16.2267C16.5403 16.0665 16.4875 15.9168 16.3607 15.7993L11.8814 11.2473C12.7899 10.168 13.3392 8.75755 13.3392 7.24036C13.3392 3.81031 10.5607 1 7.16972 1C3.7785 1 1 3.81031 1 7.24036C1 10.6702 3.7785 13.4805 7.16972 13.4805Z",
    fill: "#0e0333",
    fillOpacity: 0.4,
    stroke: "#0e0333",
    strokeOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSearchActiveSmallDisabled);
export default __webpack_public_path__ + "static/media/ic-search-active-small-disabled.970f3ab227981144741bd60ab97c19f7.svg";
export { ForwardRef as ReactComponent };